/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React, { useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { store } from '../../store';

import './submission-component.scss';

type SubmissionComponentTypes = {} & typeof defaultProps;
const defaultProps = {};

const SubmissionComponent = (props: SubmissionComponentTypes) => {
  const history = useHistory();

  const onClickDownload = async (fileType: string) => {
    if (fileType === 'png') {
      window.open('https://ao-demo-landing.s3.ap-southeast-2.amazonaws.com/templates/ao-template.png', '_blank');
    } else {
      window.open('https://ao-demo-landing.s3.ap-southeast-2.amazonaws.com/templates/ao-template.psd', '_blank');
    }
  };

  return (
    <div className="submission-component">
      <div className="submission-content">
        <div className="col left-col">
          <h2>
            Artwork Submission Details
          </h2>
          <br />
          <br />
          <div
            className="download-button"
            onClick={() => onClickDownload('psd')}
          >
            DOWNLOAD TEMPLATE
            <span>as Photoshop document</span>
          </div>
          <br />
          <div
            className="download-button"
            onClick={() => onClickDownload('png')}
          >
            DOWNLOAD TEMPLATE
            <span>as PNG image</span>
          </div>
          <br />
          <br />
          <i>Resolution</i>
          2048x2048px
          <br />
          <br />
          <i>Format</i>
          PNG or JPG
          <br />
          <br />
          <i>Art Tip</i>
          Bold shapes &amp; pattern based
          <br />
          artworks will work best!

        </div>
        <div className="col right-col">
          <ul>
            <li>
              <div className="step-image step-one" />
              <span>
                <h4>Step One</h4>
                <br />
                Download the AO Tennis Ball Texture Template.
                The template includes outlines for each section of the tennis ball.
                <br />
                <br />
                This 2D layout will then be used to wrap around and texture the 3D AO Tennis Ball.
              </span>
            </li>
            <li>
              <div className="step-image step-two" />
              <span>
                <h4>Step Two</h4>
                <br />
                Create a unique design for this project or use an existing artwork.
                <br />
                <br />
                Bold shapes &amp; patterns will work best. Any details that are too small will be
                lost amognst the fur of the tennis ball.
                <br />
                <br />
                <i>
                  (Be aware any artwork that infringes on existing Intellectual property will
                  not be used)
                </i>
              </span>
            </li>
            <li>
              <div className="step-image step-three" />
              <span>
                <h4>Step Three</h4>
                <br />
                Use the template to make sure your artwork lines up how you intend.
                Also don&apos;t forget to colour the AO logo however you wish.
                <br />
                <br />
                Please DO NOT include the template outlines in the artwork you submit.
              </span>
            </li>
            <li>
              <div className="step-image step-four" />
              <span>
                <h4>Step Four</h4>
                <br />
                Submit your artwork using the form at the top of this webpage,
                and we&apos;ll take it from there.
                <br />
                <br />
                See you on the court!
              </span>
            </li>
          </ul>
        </div>
        <div className="ball-footer" />
      </div>

    </div>
  );
};

SubmissionComponent.defaultProps = defaultProps;

export default SubmissionComponent;
